// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Tooltip from "@store/MobiusOverrides/Tooltip/Tooltip";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";
import InfoLine from "@store/Library/Components/Toolkit/Icons/Info/InfoLine";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";

interface OwnProps {
    product: ProductModel;
    isPdp?: boolean;
}

export interface productStatusStyles {
    wrapper?: InjectableCss;
    iconStyles?: IconPresentationProps;
    textBoxStyles?: TypographyPresentationProps;
    textLabelStyles?: TypographyPresentationProps;
}

export const productStatusStyles: productStatusStyles = {
    wrapper: {
        css: css`
            > div {
                margin-left: 0;
            }
        `,
    },
    iconStyles: {
        src: InfoLine,
        size: 21,
        color: "primary",
        css: spacingStyles(null, pxToRem(5)),
    },
    textBoxStyles: {
        css: css`
            margin: 0.5em 0;
            display: inline-block;
            padding: 0.25em 0.5em;
            margin-bottom: 1em;
            margin-right: 0.25em;
            background-color: ${getColor("primary.dark")};
            color: ${getColor("primary.contrast")};
            font-size: 0.75rem;
            align-self: flex-start;
        `,
    },
    textLabelStyles: {
        css: css`
            display: block;
            color: ${getColor("primary.dark")};
            width: 100%;
            margin-top: -0.8em;
        `,
    },
};

const styles = productStatusStyles;

const ProductStatus = ({ product, isPdp }: OwnProps) => {
    const statusFromAttributeTypes = product.attributeTypes?.find(attributeType => attributeType.name === "Status");

    const rawStatus = (product as any)?.properties?.status as any;
    let statusFromProperties: any;

    if (Array.isArray(rawStatus)) {
        statusFromProperties = rawStatus.find(s => s?.name === "Status");
    } else if (typeof rawStatus === "string" && rawStatus.trim()) {
        try {
            const parsed = JSON.parse(rawStatus);
            if (Array.isArray(parsed)) {
                statusFromProperties = parsed.find((s: any) => s?.name === "Status");
            }
        } catch {
            // ignore malformed JSON
        }
    }

    const statusAttribute = statusFromAttributeTypes ?? statusFromProperties;

    if (!statusAttribute) {
        return null;
    }

    const valueDisplays = statusAttribute.attributeValues?.map((v: any) => v?.valueDisplay).filter(Boolean) ?? [];

    const displayText = valueDisplays.length > 0 ? valueDisplays.join(", ") : statusAttribute.label;

    const statusDescription = product.properties?.statusDescription;

    if (!statusDescription) {
        return <Typography {...styles.textBoxStyles}>{displayText}</Typography>;
    }

    if (isPdp) {
        return (
            <>
                <Typography {...styles.textBoxStyles}>{displayText}</Typography>
                <Typography {...styles.textLabelStyles}>*{statusDescription}</Typography>
            </>
        );
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Tooltip
                text={statusDescription}
                displayOnHover={true}
                triggerComponent={
                    <>
                        <Typography {...styles.textBoxStyles}>{displayText}</Typography>
                        <Icon {...styles.iconStyles} />
                    </>
                }
            />
        </StyledWrapper>
    );
};

export default ProductStatus;
